// extracted by mini-css-extract-plugin
module.exports = {"container":"_09235a2","buttonContainer":"ba3abfd","button":"_1aefb6b","centered":"_3bd8f10","checkbox":"_8e09604"};